import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChartWaterfall"><Path d="M2.5 19.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.25 9.5V5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 14.5V4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.75 12.5V6.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChartWaterfall;
